import { faSearch, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import API_KMS from '../../../api/apiKMS';
import IconAddBlueBorder from '../../../assets/icons/IconAddBlueBorder';
import IconKMSDeleteAction from '../../../assets/icons/IconKMSDeleteAction';
import IconKMSPencilAction from '../../../assets/icons/IconKMSPencilAction';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import TableNexcare from '../../../components/Table/TableNexcare';
import MENU_KMS from '../../../constants/menuKMSConstant';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_DELETE, SETTING_KMS_INSERT, SETTING_KMS_UPDATE } from '../../../constants/menuPermissionConstant';

class KMSList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            filter: {
                field: "",
                ascending: false,
                descending: false,
            },
            columns: [
                {
                    title: "ID",
                    dataIndex: "id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    sorter: true,
                    width: "w-2/12",
                    render: (data) => `${data}`,
                },
                {
                    title: "Judul",
                    dataIndex: "title",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tipe",
                    dataIndex: "type",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (<>{this.getTypeFunction(data).label}</>),
                },
                {
                    title: "Ulasan Pengguna",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-3/12",
                    render: (data) => (
                        <div className={`${data.rating > 50 || data.total_rate === 0 ? 'bg-lightlimegreen border border-darklimegreen' : 'bg-red-100 border border-red-200'} w-1/2 rounded-xl text-center px-2 py-1 flex justify-center items-center`}>
                            <p className={data.rating > 50 || data.total_rate === 0 ? 'text-limegreen font-medium' : 'text-red-500 font-medium'}>{data.rating}%</p>
                            <p className="text-gray-600 ml-1">({data.total_rate} Ulasan)</p>
                        </div>
                    ),
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex items-center justify-between">
                            <div className="flex space-x-10">
                                <CheckPermissionComponent permissionConstant={[SETTING_KMS_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                    <div id="btnedit" className="w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.handleListKMSEdit(data)}>
                                        <IconKMSPencilAction />
                                    </div>
                                </CheckPermissionComponent>
                                <CheckPermissionComponent permissionConstant={[SETTING_KMS_DELETE]} userPermission={this.props.userDetail.permissions}>
                                    <div id="btndelete" className="w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmAlert: true, kmsDataSelectedDelete: data })}>
                                        <IconKMSDeleteAction />
                                    </div>
                                </CheckPermissionComponent>
                            </div>
                            <div id="btnview" className="bg-blue-700 rounded-full w-7 h-7 flex justify-center items-center cursor-pointer" onClick={() => this.handleListKMSDetail(data)}>
                                <FontAwesomeIcon icon={faAngleRight} className="text-white text-2xl" />
                            </div>
                        </div>
                    ),
                },
            ],
            categoryId: null,
            listKMS: [],
            searchKey: "",
            titleKMS: "",
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            kmsDataSelectedDelete: {},
        }
    }

    componentDidMount() {
        if (!this.props.history.location.state) {
            return this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
        }
        this.setState({
            categoryId: this.props.history.location.state.categoryKMSDetail.id,
            titleKMS: this.props.history.location.state.categoryKMSDetail.category,
        });
        let categoryId = this.props.history.location.state.categoryKMSDetail.id;
        let sorterValue = this.getSorterValueFunction(this.state.filter);
        this.getListKMSInitiateByCategoryId(categoryId);
        this.getDetailKMSList(this.state.pagination.current, this.state.pagination.pageSize, categoryId, sorterValue);
    }

    getListKMSInitiateByCategoryId = (categoryId) => {
        API_KMS.getListKMSInitiateByCategoryId(categoryId, this.props.token)
            .then(res => {
                this.setState({
                    pagination: { ...this.state.pagination, total: getContent(res).count_data }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDetailKMSList = (current, pageSize, categoryId, sorter) => {
        API_KMS.getListKMSByCategoryId(current, pageSize, categoryId, sorter, this.props.token)
            .then(res => {
                this.setState({
                    listKMS: getContent(res)
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getDetailKMSListSearch = (current, pageSize, categoryId, sorter, key) => {
        API_KMS.getListKMSByCategoryIdSearchTitle(current, pageSize, categoryId, sorter, key, this.props.token)
            .then(res => {
                this.setState({
                    listKMS: getContent(res)
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    getDetailKMSInitiateListSearch = (categoryId, key) => {
        API_KMS.getListKMSInitiateByCategoryIdSearchTitle(categoryId, key, this.props.token)
            .then(res => {
                this.setState({
                    pagination: { ...this.state.pagination, total: getContent(res).count_data }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getDetailKMSListSearch(this.state.pagination.current, this.state.pagination.pageSize, this.state.categoryId, sorterValue, this.state.searchKey);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getDetailKMSListSearch(this.state.pagination.current, this.state.pagination.pageSize, this.state.categoryId, sorterValue, this.state.searchKey);
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                filter: sorter
            },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getDetailKMSListSearch(this.state.pagination.current, this.state.pagination.pageSize, this.state.categoryId, sorterValue, this.state.searchKey);
            }
        );
    }

    handleSearch = e => {
        if (e.key === "Enter") {
            if (!MENU_KMS.validationTitle.test(this.state.searchKey)) {
                e.preventDefault();
                return this.setState({
                    errorMessage: "Pencarian tidak boleh mengandung spesial karakter",
                    showErrorAlertResponse: true
                })
            }
            let defaultCurrent = 1;
            let defaultPageSize = 10;
            this.setState(
                {
                    pagination: {
                        ...this.state.pagination,
                        current: defaultCurrent,
                        pageSize: defaultPageSize,
                    }
                },
                () => {
                    let sorterValue = this.getSorterValueFunction(this.state.filter);
                    this.getDetailKMSInitiateListSearch(this.state.categoryId, this.state.searchKey);
                    this.getDetailKMSListSearch(this.state.pagination.current, this.state.pagination.pageSize, this.state.categoryId, sorterValue, this.state.searchKey);
                }
            );
        }
    }

    redirectToKMSPage = () => {
        this.props.history.goBack();
    }

    handleCategoryKMSMenu = () => {
        const getIdFromHistoryState = this.props.history.location.state.categoryKMSDetail.id;
        this.props.history.push(`/settings/kms/category/detail/${getIdFromHistoryState}`);
    }

    handleListKMSAdd = () => {
        this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST_ADD, state: { categoryKMSDetail: this.props.history.location.state.categoryKMSDetail } });
    }

    handleListKMSEdit = value => {
        this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST_EDIT, state: { kmsId: value.id, categoryKMSDetail: this.props.history.location.state.categoryKMSDetail } });
    }

    handleListKMSDetail = value => {
        this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST_DETAIL, state: { kmsId: value.id, categoryKMSDetail: this.props.history.location.state.categoryKMSDetail } });
    }

    getTypeFunction = value => {
        switch (value) {
            case "C":
                return MENU_KMS.typeOptions[0];
            case "I":
                return MENU_KMS.typeOptions[1];
            case "B":
                return MENU_KMS.typeOptions[2];
            default:
                return { label: "", value: "" };
        }
    }

    getSorterValueFunction = value => {
        if (value.ascending) {
            return "ASC"
        }
        if (value.descending) {
            return "DESC"
        }
        return "ASC"
    }

    handleDeleteKMS = () => {
        this.setState({ showConfirmAlert: false })
        const kmsId = this.state.kmsDataSelectedDelete.id;
        const data = { updated_at: this.state.kmsDataSelectedDelete.updated_at };
        API_KMS.deleteDataKMS(kmsId, data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleSuccessDeleteKMS = () => {
        this.setState({
            showSuccessAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        },
            () => {
                let sorterValue = this.getSorterValueFunction(this.state.filter);
                this.getListKMSInitiateByCategoryId(this.state.categoryId);
                this.getDetailKMSList(this.state.pagination.current, this.state.pagination.pageSize, this.state.categoryId, sorterValue);
            }
        )
    }

    render() {
        return (
            <>
                <div className="space-y-3">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="KMS"
                        menuItem="Daftar KMS"
                        title="Knowledge Management Sistem"
                    />

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-24">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8">
                            {/* MENU HEADBAR */}
                            <div className="flex items-center space-x-5 text-2xl text-gray-700 pb-10">
                                <button className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY) ? "active-menu-kms font-medium" : "font-medium"} onClick={this.handleCategoryKMSMenu}>
                                    Kategori KMS
                                </button>
                                <button className={`
                                    ${window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_LIST) ? "active-menu-kms font-medium" : "font-medium"}
                                    "cursor-pointer"
                                `}
                                >
                                    Daftar KMS
                                </button>
                            </div>
                            {/* CONTENT */}
                            <div className="space-y-4">
                                <div className="flex justify-between items-center">
                                    {/* Search */}
                                    <div className="bg-white w-1/4 h-12 rounded p-3 mt-1 focus-within:border-gray-400 border">
                                        <div className="flex items-center rounded-full bg-white px-2">
                                            <input id="tslkeyword" type="text" placeholder={"Cari Judul"} className="outline-none w-full" onKeyDown={this.handleSearch} onChange={(e) => { this.setState({ searchKey: e.target.value }) }} />
                                            <div>
                                                <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                                            </div>
                                        </div>
                                    </div>
                                    <CheckPermissionComponent permissionConstant={[SETTING_KMS_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        {/* Add KMS */}
                                        <div
                                            id="btnadd"
                                            className="flex items-center cursor-pointer bg-olddarkblue text-white py-2 px-6 rounded-lg"
                                            onClick={this.handleListKMSAdd}
                                        >
                                            <IconAddBlueBorder />
                                            <span className="ml-2">Tambah KMS</span>
                                        </div>
                                    </CheckPermissionComponent>
                                </div>
                                {/* Title KMS List */}
                                <div className="font-semibold text-gray-800 w-1/2 truncate" title={this.state.titleKMS}>{this.state.titleKMS}</div>
                                {/* Table KMS List */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listKMS}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        onSorter={this.handleSorter}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Alert show={this.state.showConfirmAlert} button={true} title="Hapus KMS?" desc={"Apakah Anda yakin ingin menghapus data?"} close={() => this.setState({ showConfirmAlert: false, kmsDataSelectedDelete: {} })} submit={() => this.handleDeleteKMS()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil dihapus"} close={this.handleSuccessDeleteKMS} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSList);